module.exports = __webpack_public_path__ + "img/keyboard-no.473a2fbf.png";